import React, { FC, Fragment } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Loaders } from 'components';
import { LINE_CHART_HEIGHT } from '../../constants';

interface Props {
  text: string;
}

const useStyles = makeStyles(theme => ({
  text: theme.mixins.absoluteCenter,
}));

const LineChartEmptyState: FC<Props> = ({ text }) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Loaders.LineChart placeholderMode height={LINE_CHART_HEIGHT} />
      <Typography align="center" variant="subtitle2" className={classes.text}>
        {text}
      </Typography>
    </Fragment>
  );
};

export default LineChartEmptyState;
